import useScrollTriggerContext from '@contexts/scrollTriggerContext'
import { colors, size } from '@styles/theme'
import { PiArrowUpBold, PiSpinnerBold } from 'react-icons/pi'
import { Button } from '@mui/material'
import styled from '@emotion/styled'

const StyledButton = styled(Button)`
  position: absolute;
  top: ${size(12)};
  left: calc(50% - ${size(10)});

  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size(20)};
  border-radius: 100px;
  z-index: 10;

  background-color: ${colors.statusColors.right_now('primary')} !important;
  white-space: nowrap;
`

const CheckNewPostsButton = ({ checkButtonState, onClick, noDisplay, ...rest }) => {
  const { isPostsCheckableLoading, isPostsCheckableLoadingDelayed, checkBtnMessage, isNewPostsCheckable } = checkButtonState
  const { scrollTrigger } = useScrollTriggerContext()

  const renderContents = () => {
    if (checkBtnMessage) {
      return checkBtnMessage
    } else if (isPostsCheckableLoadingDelayed) {
      return <><PiSpinnerBold size={size(1.85)} className='animation_rotation' />&nbsp;Loading posts</>
    } else {
      return <><PiArrowUpBold size={size(1.85)} strokeWidth={6} style={{ paddingBottom: 2, flexShrink: 0 }} />&nbsp;Check new posts</>
    }
  }

  const handleClick = (e) => {
    if (!isPostsCheckableLoading && !checkBtnMessage) {
      return onClick(e)
    }
  }

  const handleButtonDisplay = () => {
    // NOTE: this can be condensed, but I wanted to make the different conditions
    //       which the button can/should be seen more understandable.
    let canDisplay = false
    
    // display if posts are checkable, and display isn't being blocked externally
    if (isNewPostsCheckable && !noDisplay) canDisplay = true
    
    // display loader if the loading has become delayed
    else if (isPostsCheckableLoadingDelayed) canDisplay = true
    
    // display the check button message as needed
    else if (checkBtnMessage) canDisplay = true

    // style object for button returned
    return { display: canDisplay ? 'flex' : 'none' }
  }

  return (
    <StyledButton
      onClick={handleClick}
      className={scrollTrigger ? 'animation__hide-top-nav-check-new-posts' : 'animation__show-top-nav-check-new-posts'}
      variant='contained'
      style={handleButtonDisplay()}
      {...rest}>
      {renderContents()}
    </StyledButton>
  )
}

export default CheckNewPostsButton
